import { FC } from "react";
import { makeStyles, Theme } from "@material-ui/core/styles";
import checkIcon from 'src/assets/blue-check.svg';
import { Typography } from "@material-ui/core";

interface RadioBtnProps {
  id: string;
  label: string;
  value: string;
  checked: boolean;
};

const RadioBtn: FC<RadioBtnProps> = ({ id, label, value, checked }) => {
    const classes = useStyles();

    return (
      <label
        htmlFor={id}
        className={classes.root}>
        <input
          id={id}
          className={classes.input}
          type="radio"
          value={value}
          checked={checked} />
          <Typography className={classes.label}>{label}</Typography>
      </label>
    );
};

RadioBtn.defaultProps = { };

export default RadioBtn;

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    width: "90%",
    padding: "16px 5% 16px 5%",
    margin: "13px 0 0 0",
    borderRadius: "4px",
    backgroundColor: "#f8f8f8",
    display: "flex",
    alignItems: "center",
    cursor: "pointer",
  },
  label: {
    marginLeft: "15px",
    fontFamily: "Poppins",
    fontSize: "14px",
    fontWeight: 500,
    color: "#1d262c",
  },
  input: {
    width: "1.25rem",
    height: "1.25rem",
    border: "solid 1px #0091ff",
    appearance: "none",
    borderRadius: "50%",
    cursor: "pointer",

    "&:checked": {
        border: "none",
        backgroundImage: `url(${checkIcon})`,
        backgroundSize: "19px",
    }
  }
}));

